module.exports = __webpack_public_path__ + "static/media/fistFlexed22Right.677ab859.png";